import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section className="py-24 md:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 max-w-2xl"
        >
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.25em] text-seed-salad">Depoimentos</p>
          <h2 className="font-heading text-4xl font-black tracking-tighter text-seed-deep sm:text-5xl" data-testid="testimonials-title">
            Quem conquistou com a Seed.
          </h2>
        </motion.div>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {items.map((t, i) => (
            <motion.blockquote
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="rounded-lg bg-white p-8 shadow-sm"
              data-testid={`testimonial-${t.id.slice(0, 8)}`}
            >
              <Quote size={24} className="text-seed-vivid" />
              <p className="mt-5 text-base leading-relaxed text-seed-deep/80">“{t.text}”</p>
              <footer className="mt-6 border-t border-seed-deep/10 pt-4">
                <p className="font-heading text-sm font-bold text-seed-deep">{t.name}</p>
                {t.city && <p className="text-xs text-seed-deep/50">{t.city}</p>}
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
